import React, { useEffect, useState } from 'react';

import CloseIcon from '@material-ui/icons/Close';
import { FilledInput, FormControl, Grid, IconButton, InputAdornment, InputLabel } from '@material-ui/core';

import DefaultTable from '../../components/DefaultTable';
import PageWrapper from '../../components/PageWrapper';
import SaveBox from '../../components/SaveBox';

import Search from '@material-ui/icons/Search';
import * as CellType from '../../components/CellType';
import companyEndpoints from '../../../../api/services/companyEndpoints';
import helpers from '../../../../utils/helpers';
import { useTableReducer } from '../../hooks/useTableReducer';

const FindCompany = ({ onClose, onSave, requestParams = {} }) => {
    const [selectedTemp, setSelectedTemp] = useState([]);
    const [loading, setLoading] = useState(false);

    const [orderBy, setOrderBy] = useState('cdEmpresa');
    const [orderDirection, setOrderDirection] = useState('desc');
    const [searchTxt, setSearchTxt] = useState('');
    const [rows, setRows] = useState([]);

    const [companies, actions] = useTableReducer({ pageSize: 5 });
    const { changePage, changePageSize, resetTable, loadData: loadCompanies } = actions;

    const [tableColumns] = useState([
        { id: 4, fieldName: 'cdEmpresa', title: '', Component: CellType.OfRadio },
        { id: 1, fieldName: 'deCnpjMatriz', title: 'CNPJ' },
        { id: 2, fieldName: 'deRazaoSocial', title: 'Razão Social' },
    ]);

    const [filters, setFilters] = useState(() => {
        return {
            ...requestParams,
            campoOrdenacao: orderBy,
            direcaoOrdenacao: orderDirection,
        };
    });

    useEffect(() => {
        (async () => {
            setLoading(true);
            const params = { page: companies.page, size: companies.pageSize, request: filters };
            const response = await companyEndpoints.getCompanies(params);
            if (response && response.status === 200) {
                let data = response.data;
                if (data.content.length === 0) {
                    resetTable();
                } else {
                    loadCompanies(data);
                }
            }
            setLoading(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companies.page, companies.pageSize, filters]);

    const prepareRows = (data) => {
        if (!data) return [];
        return data.map((row) => {
            const temp = { ...row };
            temp.deCnpjMatriz = helpers.formatarDocumento(temp.deCnpjMatriz);
            return temp;
        });
    };

    useEffect(() => setRows(prepareRows(companies.content)), [companies]);

    const handleSelect = ({ data }) => {
        setSelectedTemp(data);
    };

    const handleSaveSelected = () => {
        if (onSave) {
            onSave(selectedTemp);
        }
        onClose();
    };

    const handleChangePageSize = (e) => {
        changePage(0);
        changePageSize(parseInt(e.target.value));
    };

    const handleChangePage = (e, page) => {
        changePage(page);
    };

    const handleChangeOrder = (event, property) => {
        let tempDirection = orderDirection;
        if (property === orderBy) {
            tempDirection = orderDirection === 'desc' ? 'asc' : 'desc';
        }
        const temp = { ...filters };
        temp['campoOrdenacao'] = `${property}`;
        temp['direcaoOrdenacao'] = tempDirection;
        setOrderDirection(tempDirection);
        setOrderBy(property);
        setFilters(temp);
        handleChangePage(null, 0);
    };

    const handleTextSearch = (onBlur) => {
        if (onBlur) {
            if (searchTxt !== '') return;
        }
        handleChangeFilter('txtBusca', searchTxt);
        // setPage(0);
    };

    const handleChangeFilter = (key, value) => {
        const temp = { ...filters };
        temp[key] = value;
        setFilters(temp);
    };

    return (
        <PageWrapper
            maxWidth="md"
            title="Buscar empresa"
            isPlain
            actionButton={
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            }>
            <Grid item xs={12} container spacing={2}>
                <Grid item xs={4}>
                    <FormControl size="small" variant="filled" fullWidth>
                        <InputLabel>Buscar</InputLabel>
                        <FilledInput
                            id="outlined-adornment-weight"
                            value={searchTxt}
                            onChange={(e) => setSearchTxt(e.target.value)}
                            endAdornment={
                                <InputAdornment
                                    position="end"
                                    onClick={() => handleTextSearch()}
                                    style={{ cursor: 'pointer' }}>
                                    <Search />
                                </InputAdornment>
                            }
                            aria-describedby="outlined-weight-helper-text"
                            inputProps={{
                                'aria-label': 'weight',
                            }}
                            onBlur={() => {
                                handleTextSearch(true);
                            }}
                            onKeyPress={(ev) => {
                                if (ev.key === 'Enter') {
                                    ev.preventDefault();
                                    handleTextSearch();
                                }
                            }}
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <DefaultTable
                        loading={loading}
                        columns={tableColumns}
                        rows={rows}
                        entryProps={{
                            onChangeSelect: handleSelect,
                            selectedId: selectedTemp?.cdEmpresa,
                        }}
                        paginationProps={{
                            rowsPerPageOptions: [5, 10, 25],
                            count: companies.count,
                            rowsPerPage: companies.pageSize,
                            page: companies.page,
                            onPageChange: handleChangePage,
                            onRowsPerPageChange: handleChangePageSize,
                        }}
                        orderBy={orderBy}
                        order={orderDirection}
                        onRequestSort={handleChangeOrder}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SaveBox
                        firstButtonLabel={'VOLTAR'}
                        middleButtonLabel="Adicionar"
                        onSave={handleSaveSelected}
                        onCancel={onClose}
                    />
                </Grid>
            </Grid>
        </PageWrapper>
    );
};

export default FindCompany;
